export const DEFAULT_MODULES = {
  dashboard: true,
  receiving: true,
  production: true,
  packaging: true,
  inventory: true,
  orders: true,
  shipping: true,
  qa: true,
  reports: true,
  customers: true,
  suppliers: true,
  purchase_orders: true,
  lab_samples: true,
  traceability: true,
};

export const MODULE_OPTIONS = [
  { key: "dashboard", label: "Dashboard" },
  { key: "receiving", label: "Receiving" },
  { key: "production", label: "Production" },
  { key: "packaging", label: "Packaging" },
  { key: "inventory", label: "Inventory" },
  { key: "orders", label: "Orders" },
  { key: "shipping", label: "Shipping" },
  { key: "qa", label: "Quality Assurance" },
  { key: "reports", label: "Reports" },
  { key: "customers", label: "Customers" },
  { key: "suppliers", label: "Suppliers" },
  { key: "purchase_orders", label: "Purchase Orders" },
  { key: "lab_samples", label: "Lab Samples" },
  { key: "traceability", label: "Traceability" },
];

export function tenantModules(tenant) {
  return { ...DEFAULT_MODULES, ...(tenant?.settings?.modules ?? {}) };
}

export function moduleEnabled(tenant, key) {
  const modules = tenant?.settings?.modules;
  if (!modules) {
    return DEFAULT_MODULES[key] !== false;
  }
  return modules[key] !== false;
}
